import styled from "styled-components";
import { COLORS } from "../../../utils/constants";

export const Wrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const Label = styled.label<{ disabled?: boolean }>`
  font-weight: 600;
  font-size: 1rem;
  color: ${COLORS.WHITE};
  font-family: StabilGrotesk, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    color: ${COLORS.DUST_WHITE} !important;
  `}
`;

export const Radio = styled.input`
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  width: 1.5em;
  height: 1.5em;
  border: 2px solid ${COLORS.GREEN};
  border-radius: 50%;
  transition: all 0.1s ease-in-out;
  ::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 0.75em;
    height: 0.75em;
    margin: 3px;
  }
  :checked {
    ::after {
      background-color: ${COLORS.GREEN};
    }
    :hover {
      border: 2px solid ${COLORS.GREEN};
      ::after {
        background-color: ${COLORS.GREEN};
      }
    }
  }
  :focus {
    outline: 2px solid ${COLORS.GREEN};
  }
  :hover {
    ::after {
      background-color: ${COLORS.GREEN};
    }
  }
  :disabled {
    cursor: not-allowed;
    border: 2px solid ${COLORS.GREEN};
    background-color: ${COLORS.GREEN};
    :hover {
      ::after {
        background-color: ${COLORS.GREEN};
      }
    }
    :checked {
      ::after {
        background-color: ${COLORS.GREEN};
      }
      :hover {
        background-color: ${COLORS.GREEN};
        ::after {
          background-color: ${COLORS.GREEN};
        }
      }
    }
  }
`;
